import axios from '../axios';

/**
 * Products API - כל הפונקציות הקשורות למוצרים
 */

export const productsApi = {
  // קבלת כל המוצרים
  getAll: async (params = {}) => {
    try {
      const response = await axios.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // קבלת מוצרים לפי קטגוריה
  getByCategory: async (category) => {
    try {
      const response = await axios.get(`/products/category/${category}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching products by category ${category}:`, error);
      throw error;
    }
  },

  // קבלת מוצר בודד
  getById: async (id) => {
    try {
      const response = await axios.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching product ${id}:`, error);
      throw error;
    }
  },

  // קבלת מוצרים מומלצים
  getFeatured: async () => {
    try {
      const response = await axios.get('/products/featured');
      return response.data;
    } catch (error) {
      console.error('Error fetching featured products:', error);
      throw error;
    }
  },

  // קבלת מוצרים מומלצים
  getRecommended: async () => {
    try {
      const response = await axios.get('/products/recommendations');
      return response.data;
    } catch (error) {
      console.error('Error fetching recommended products:', error);
      throw error;
    }
  },

  // יצירת מוצר חדש (admin only)
  create: async (productData) => {
    try {
      const response = await axios.post('/products', productData);
      return response.data;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  // עדכון מוצר (admin only)
  update: async (id, productData) => {
    try {
      const response = await axios.put(`/products/${id}`, productData);
      return response.data;
    } catch (error) {
      console.error(`Error updating product ${id}:`, error);
      throw error;
    }
  },

  // מחיקת מוצר (admin only)
  delete: async (id) => {
    try {
      const response = await axios.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting product ${id}:`, error);
      throw error;
    }
  },

  // החלפת סטטוס מוצר מומלץ (admin only)
  toggleFeatured: async (id) => {
    try {
      const response = await axios.patch(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error toggling featured status for product ${id}:`, error);
      throw error;
    }
  },

  // קבלת SKU הבא לקטגוריה (admin only)
  getNextSKU: async (category) => {
    try {
      const response = await axios.get(`/products/next-sku/${category}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting next SKU for category ${category}:`, error);
      throw error;
    }
  }
};

export default productsApi; 